import React from 'react'
import PropTypes from 'prop-types'
import withSnack from '../withSnack'
import DocBody from '../DocBody'
import DocHeader from '../DocHeader'
import DocFooter from '../DocFooter'
import DocActionButtons from '../DocActionButtons'
import DocStore from '../../stores/DocStore'
import SettingStore from '../../stores/SettingStore'
import { debounce } from 'lodash'
import DocPrintDetails from '../DocPrintDetails'
import ApiCalendar from 'react-google-calendar-api'
import withStyles from '@material-ui/core/styles/withStyles'
import DocHistoryDetails from '../DocHistoryDetails'
import { Hidden, Grid, Dialog, Button, IconButton } from '@material-ui/core'
import DocRequiredField from '../DocRequiredField'
import moment from 'moment'
import TempProfileModal from '../TempProfileModal'
import DelegateStore from '../../stores/DelegateStore';
import UserStore from '../../stores/UserStore';
import Typography from '@material-ui/core/Typography';
import generatePDF from '../../functions/generatePDF'
import { ErrorMessageModal } from '../DocDialogs'
import GroupedDetails from '../GroupedDetails'
import DocAdditionalDetails from '../DocAdditionalDetails'
import { Print, ArrowBack } from '@material-ui/icons'
import { CustomTooltip } from '../CustomTooltip'
import DocPhysicalDetails from '../DocPhysicalDetails'

const styles = {
  root: {
    padding: '5%'
  },
}

class DocEditor extends React.Component {
  state = {
    doc: {},
    isLoaded: false,
    valid: false,
    saveMessage: '',
    noteAdded: false,
    alreadyAdded: '',
    preview: false,
    slogan:"",
    isOpenTempProfile: false,
    tempProfile: {},
    params: {
      ...UserStore.info(),
      hasDelegates: false,
      isDelegate: false,
      isReviewer: false
    },
    allowEdit: false,
    errorMessageUpload: false,
  }

  addWSCheckRead = doc => {
    if (!doc.read && doc.sent && this.subs === undefined)
      this.subs = DocStore.getReadChannel(doc.id, data => {
        this.setState(prevState => {
          //data is supposed to be like  {read: true, read_detail:[ ]}
          return {...prevState, doc: {...prevState.doc, ...data}}
        })
      })
  }

  onAddCC = (event, {suggestion}) => {
    //opens modal if profile is incomplete
    if (suggestion.temp === true){
      this.openTempProfileModal(suggestion, 'cc');
    }
    else{
      this.successCC(suggestion)
    }
}

onAddExternalCC = (name, job_title) => {
    this.updateDocNestAttributes({
      notices_attributes: {
        0: {
          note: this.state.doc.notices_attributes[0] ? this.state.doc.notices_attributes[0].note : '',
          from_id: this.state.doc.from.id,
          notice_users_attributes: {
            0: {
              to_id: '',
              user_group_id: '',
              external: true,
              ext_name: name,
              ext_job_title: job_title,
              _destroy: false,
            }
          },
          _destroy: false,
          id: this.state.doc.notice_user_list.length > 0 ? this.state.doc.notices_attributes[0].id : ''
        }
      }
    })
}

successCC = (suggestion) => {

  this.setState({alreadyAdded: ''})
  const user_id = suggestion.group ? '' : (suggestion.id ? suggestion.id : suggestion.email)
  const user_group_id = suggestion.group ? suggestion.id : '';
  const exist = this.state.doc.notice_user_list.find(function (element) {
    return element.to === null ? false : element.group === true ? (element.group === true && suggestion.group === true && element.to.id === suggestion.id) :
      (element.to.id === suggestion.id && element.group === false) || (element.to.email === suggestion.id && element.group === false)
  })
  const FromAndCCDuplicated = (suggestion.group && this.state.doc.to.id !== suggestion.id)? false : this.state.doc.from.email === user_id || this.state.doc.from.id === user_id
  || this.state.doc.to.email === user_id || this.state.doc.to.id === user_id ? true : false

  if (!exist && !FromAndCCDuplicated) {
      this.updateDocNestAttributes({
        notices_attributes: {
          0: {
            note: this.state.doc.notices_attributes[0] ? this.state.doc.notices_attributes[0].note : '',
            from_id: this.state.doc.from.id,
            notice_users_attributes: {
              0: {
                to_id: user_id,
                user_group_id: user_group_id,
                _destroy: false,
              }
            },
            _destroy: false,
            id: this.state.doc.notice_user_list.length > 0 ? this.state.doc.notices_attributes[0].id : null
          }
        }
      })
  } else {
    if (!FromAndCCDuplicated) {
      this.setState({alreadyAdded: [!!exist.group, exist.to.id ? exist.to.id : exist.to.email]})
    }
  }
}


  onDeleteCC = (suggestion) => {
    const notice_id = suggestion.id ? suggestion.id : suggestion.email
      this.updateDocNestAttributes({
        notices_attributes: {
          0: {
            note: this.state.doc.notices_attributes[0] ? this.state.doc.notices_attributes[0].note : '',
            from_id: this.state.doc.from.id,
            notice_users_attributes: {
              0: {
                id: notice_id,
                _destroy: 1,
              }
            },
            _destroy: this.state.doc.notice_user_list.length > 1? false : 1,
            id: this.state.doc.notices_attributes[0].id
          }
        }
      })
  }

  // this mess is because we are nesting states, which is a bad practice for react , the easiest solution would be used
  //this call updates one user without update it
  onCcNoteChange = value => {
    this.updateDocNestAttributes({
      notices_attributes: {
        0: {
          note: value,
          from_id: this.state.doc.from.id,
          notice_users_attributes: {
            0: {
              id: this.state.doc.notice_user_list[0].id,
              _destroy: false,
            }
          },
          _destroy: false,
          id: this.state.doc.notices_attributes[0].id
        }
      }
    })
  }

  isBodyValid = v => {
    this.setState({valid: v})
  }

  onDeleteFile = f => {
    const doc_id = this.state.doc.id
    DocStore.deleteFile(doc_id, f).then(r => {
      this.setState(ps => {
        return {...ps, doc: {...ps.doc, files: r.data}}
      })
    })
  }

  onFileUpload = (e, onProgress) => {
    const files = e.target.files
    const doc_id = this.state.doc.id
    DocStore.uploadFile(doc_id, files, onProgress).then(r => {

      this.setState(ps => {
        return {...ps, doc: {...ps.doc, files: r.data} }
      })
    }).catch((error) => {
      if((typeof  error.response !== 'undefined') && (error.response.status === 422))
        this.setState({ errorMessageUpload: true })
    })
  }

  //Nested attributes always expect for notice_users_attributes, so backend ask for sth
  onEventSave = event => {
    DocStore.save_event(this.state.doc.id, event).then(r => {
      this.setState(ps => {
        return {...ps, doc: {...ps.doc, event: r.data}}
      })
    })
  }

  // this mess is because we are nesting states, which is a bad practice for react , the easiest solution would be used
  onToChange = to => {
    if (to.group === true){
      this.updateDoc({user_group_id: to.id, to_id: null, to: to})
    }
    else{
      this.updateDoc({to_id: to.id, user_group_id: null, to: to})
      if(to.temp === true){
        this.openTempProfileModal(to, 'add')
      }
    }
  }

  openTempProfileModal = (user,type,event) => {
    this.setState({ isOpenTempProfile: true,
      tempProfile:{ ...user, type: type }
     })
  }

  closeTempProfileModal = (title, job_title, action) => {
    // if type is addressee
    if(this.state.tempProfile.type === 'add'){
      this.updateDoc({
        to: {
          ...this.state.doc.to,
          job_title: job_title,
          name:{...this.state.doc.to.name, title: title}
        }
      })
    }

    //if type is cc
    if(this.state.tempProfile.type === 'cc' && action === 'success'){
      this.successCC(this.state.tempProfile);
    }

    //clear state and close modal
    this.setState({
      isOpenTempProfile: false,
      tempProfile: {}
     })
  }

  //normal comments
  onSendComment = revisionNotes => {
    DocStore.save_comment(this.state.doc.id, revisionNotes).then(r => {
      this.setState(ps => {
        return {...ps, doc: {...ps.doc, revisionNotes: r.data}}
      })
      this.props.snack('Revisión enviada con éxito', 'success')
    })

    this.setState({noteAdded: true})
  }

  //approve comments
  onSendCommentApprove = revisionNotes => {
    DocStore.save_comment_approve(this.state.doc.id, revisionNotes).then(r => {
      this.setState(ps => {
        return {...ps, doc: {...ps.doc, revisionNotes: r.data}}
      })
      this.props.snack('Revisión enviada con éxito', 'success')
    })

    this.setState({noteAdded: true})
  }

  onBodyChange = value => {
    this.updateDoc({body: value})
  }

  onDateChange = value => {
      this.updateDoc({date: value})
  }

  onSubjectChange = value => {
      this.updateDoc({subject: value})
  }

  onSwitchFrom = user => {
    this.updateDoc({
      from_id: user.id,
      from: user,
    })
      if (this.state.doc.notice_user_list.length > 0) {
        this.updateDocNestAttributes({
          notices_attributes: {
            0: {
              note: this.state.doc.notices_attributes[0] ? this.state.doc.notices_attributes[0].note : '',
              from_id: user.id,
              notice_users_attributes: {
                0: {
                  id: this.state.doc.notice_user_list[0].id,
                  _destroy: false,
                }
              },
              _destroy: false,
              id: this.state.doc.notices_attributes[0].id
            }
          }
        })
      }
  }

  updateDoc = shallow => {
    this.setState({saveMessage: 'Guardando...'})
    this.setState(prevState => {
      const ns = {...prevState, doc: {...prevState.doc, ...shallow}}
      //Another treatment for saving this changes without notices_attributes updates
      const nsFiltered = {...prevState, doc: {...prevState.doc, notices_attributes: {}, ...shallow}}
      if (shallow.id) {
        this.save(shallow)
      } else {
        this.save(nsFiltered.doc)
      }
      return ns
    })
  }

  updateDocNestAttributes = shallow => {
    this.setState({saveMessage: 'Guardando...'})
    this.setState(prevState => {
      const ns = {...prevState, doc: {...prevState.doc, ...shallow}}
      if (shallow.id) {
        this.save(shallow)
      } else {
        this.save(ns.doc)
      }
      return ns
    })
  }

  updateDocForward = (doc_id, notice_attributes, option, originalTo) => {
    DocStore.resend(doc_id, notice_attributes, option, originalTo).then(r => {
      this.props.snack('Folio reenviado con éxito', 'success')
      this.setState(prevState => {
        return {...prevState, doc: {...prevState.doc, ...r.data}}
      })
    })
  }

  save_fails = () => {
    if (this.state.doc.pending === false) {
      this.setState({saveMessage: 'Error al guardar'})
    }
  }

  save = debounce(new_data => {

    DocStore.save(new_data).then(r => {
      if (this.state.doc.id !== '' && this.state.doc.sent === false) {
        this.setState({saveMessage: 'Guardado con éxito'})
      }

      this.setState(prevState => {
        if ((prevState.doc.id === undefined) && (r.data.id !== undefined)) {
          this.props.history.replace(`/oficios/${r.data.id}`)
        }
        return {...prevState, doc: {...prevState.doc, ...r.data}}
      })
    }, this.save_fails)
  }, 1000)
  send_fail = (m) => {
    switch(m){
      case 'group must have at least one user':
        this.props.snack('Error al enviar, el grupo debe tener al menos un usuario', 'warning')
        break;
      case 'event must be at later date than today':
        this.props.snack('Error al enviar, la fecha del evento programado no es válida', 'warning')
        break;
      default:
        this.props.snack(m, 'warning')
        break;
    }
  }

  printDoc = () => {
    const oficio = this.state.doc;
    const objectToPrint = {
      folio: oficio.folio,
      date: oficio.date,
      from: oficio.from.name.title + ' ' + oficio.from.name.full + ' - ' + oficio.from.job_title + ' (' + oficio.from.email + ')',
      to: (oficio.to.group === true)? oficio.to.name.title + ' ' + oficio.to.name.full : oficio.to.name.title + ' ' + oficio.to.name.full + ' - ' + oficio.to.job_title + ' (' + oficio.to.email + ')',
      content: oficio.body,
      cc: oficio.notice_user_list,
      subject: typeof oficio.subject !== 'string'? ' ' :  oficio.subject
    }
    generatePDF(objectToPrint)
  }

  disableEditDoc = () => {
    this.setState({ allowEdit: true })
  }

  onSend = (role) => {
    const doc = this.state.doc
    if (doc.event.id !== null && !ApiCalendar.sign) {
      ApiCalendar.handleAuthClick()
      return this.props.snack(
        'Es necesario autenticarte con Google para continuar ', 'warning'
      )
    }

    DocStore.send_or_sign(doc).then(r => {
      this.setState({saveMessage: ''})
      this.setState(prevState => {
        this.setState({ allowEdit: false })
        if(role === 'delegated'){
            this.props.snack('Solicitud de firma enviada con éxito', 'success')
        }
        else{
            this.props.snack('Folio enviado con éxito', 'success')

        }

        this.addWSCheckRead(r.data)
        this.closePreview()
        return {...prevState, doc: r.data}
      })
      if (r.data.sent === true && r.data.pending !== true)
        DocStore.send_event(r.data.event).then(r => {
          if (r.status === 200) {
            this.props.snack('Evento enviado con éxito', 'success')
            return DocStore.save_event(JSON.parse(r.body))
          }
          if (r.status !== 204) {
            this.props.snack('El evento no pudo ser enviado', 'warning')
          }
        })
        this.printDoc()
    })
      .catch((error) => {
        this.send_fail(error.response.data.error)
      })
  }

  ask_or_grant_revision = (role) => {
    const doc = this.state.doc

    DocStore.handleRevision(doc).then(r => {
      this.setState({saveMessage: '', allowEdit: false})
      this.setState(prevState => {
        this.props.snack('Solicitud de revisión enviada con éxito', 'success')
        this.addWSCheckRead(r.data)
        this.closePreview()
        return {...prevState, doc: r.data}
      })
    })
      .catch((error) => {
        this.send_fail(error.response.data.error)
      })
  }

  onSendAprove = (user) => {
    DocStore.send_aprove(user, this.state.doc.id).then(r => {
      this.setState({saveMessage: ''})
      this.setState(prevState => {
        this.props.snack('Oficio Aprobado con éxito', 'success')
        this.addWSCheckRead(r.data)
        return {...prevState, doc: r.data}
      })
    })
      .catch((error) => {
        this.send_fail(error.response.data.error)
      })
  }

  openPreview = () => {
    this.setState({preview: true})
  }

  closePreview = () => {
    this.setState({preview: false})
  }

  onReset = () => {
    this.updateDoc({
      to: {
        department: '',
        institution: '',
        email: '',
        id: null,
        job_title: '',
        name: {
          title: '',
          full: ''
        }
      }
    })
    if (this.state.isOpenTempProfile === true){
      this.setState({ isOpenTempProfile: false})
    }
  }

  setParams = () => {
  //
    DelegateStore.getUsersOnBehalf().then(r => {
      if(r.data.length > 1){
        this.setState({ params: {...this.state.params, isDelegate: true } });
      }
    });

  //
    DelegateStore.listUsers('delegate').then(r => {
      if(r.data.length > 0){
        this.setState({ params: {...this.state.params, hasDelegates: true } });
      }
    });

  //
    DelegateStore.getUsersOnBehalfReviewer().then(r => {
      if(r.data.length > 1){
        this.setState({ params: {...this.state.params, isReviewer: true } });
      }
    });
  }

  componentDidMount () {
    document.title = "GO | Oficio";
    this.setParams();
    const id = this.props.match.params.id
    DocStore.getDoc(id).then(
      r => {
        this.setState({doc: r.data, isLoaded: true})
        this.addWSCheckRead(r.data)
      },
      e => {
        switch (e.response.status) {
          case 403:
            this.props.snack('Acceso denegado', 'warning')
            break
          case 404:
            this.props.snack('No encontrado', 'warning')
            break
          default:
            this.props.snack('Error', 'warning')
        }
      }
    )

    SettingStore.getSlogan().then(
      r =>{this.setState({slogan: r})})
  }

  onChangeAddressee = (field,value) => {
      //actualizo los parametros para el oficio externo
      this.setState({
        doc: {...this.state.doc, [field]: value}
      })

      //guardo los parametros para el oficio externo
      this.updateDoc({
         [field]: value
      });
  }

  onChangeTypeAddressee = (type) => {
    // actualizo si el destinatario del oficio va a ser externo o no
    this.setState({
      doc: {...this.state.doc, external: type}
    })

    // guardo el tipo del destinatario y quito el destinatario no externo(to_id) en caso que exista
      this.updateDoc({
        to_id: null,
        external: type,
      })

    //reseteo los valores del destinatario to(correo, titulo, etc) del oficio
    this.onReset();

    // si type es false quito los valores de oficio externo
    if(!type){
      this.updateDoc({
        ext_name: '',
        ext_job_title: '',
      })
    }
  }

  onReplyDoc = (doc, all) => {
    DocStore.replyDoc(doc, all).then(r => {
      //save state
      this.setState({
        doc: {...r.data,
              notice_user_list:  ((all) && (typeof r.data.notices_attributes[0] !== 'undefined'))? r.data.notices_attributes[0].notice_users_attributes : []
            },
        isLoaded: true
      })

      //var for notices_attributes
      let notices_attributes = []

      //if replay is for all I add params
      if(all){
        notices_attributes = {
          0: {
              note: 'respuesta de reenvío',
              from_id: r.data.to.id,
              notice_users_attributes: {},
              _destroy: false,
              id: null
              }
        }

        //if notices_attributes[0] isn't undefined
        if(typeof r.data.notices_attributes[0] !== 'undefined'){
          const cc_users =  r.data.notices_attributes[0].notice_users_attributes;

          //loop for fill notices_attributes
          cc_users.forEach((user, index) => {
            notices_attributes[0].notice_users_attributes[index] = {
              to_id: user.to.id,
              user_group_id: user.to.group? user.to.id : null,
              _destroy: false,
            }
          });
        }
      }

      //save data
      this.updateDoc({
        to: r.data.to,
        to_id: r.data.to.id,
        notices_attributes: notices_attributes
      })

    })
    .catch((error) => {
      this.props.snack('Error al responder el oficio', 'warning')
    })
  }

  onAskPhysicalDoc = () => {
    const doc_id = this.state.doc.id

    if(typeof doc_id === 'number'){
      DocStore.askPhysicalDoc(doc_id).then(r => {
        this.props.snack('Solicitud de envío en físico enviada exitosamente', 'success')
          this.setState({ doc:{...this.state.doc, requested_physical: true }});
      })
      .catch((error) => {
        this.props.snack('Error al realizar la solicitud', 'warning')
      })
    }
    else{
      this.props.snack('Error al solicitar oficio en físico', 'warning')
    }
  }

  onSendPhysicalDoc = (to, index) => {
    const doc_id = this.state.doc.id
    const rd = this.state.doc.readDetail

    if(typeof doc_id === 'number'){
      DocStore.sendPhysicalDoc(doc_id, to).then(r => {
        this.props.snack('Confirmación de envío en físico enviada exitosamente', 'success')
        // 1. Make a shallow copy of the items
        let items = [...rd];

        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};

        // 3. Replace the property you're intested in
        item.sent_physical = true;

        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;

        // 5. Set the state to our new copy
        this.setState({ doc:{...this.state.doc, readDetail: items }});
      })
      .catch((error) => {
        this.props.snack('Error al enviar la confirmación', 'warning')
      })
    }
    else{
      this.props.snack('Error al enviar la confirmación de envió en físico', 'warning')
    }
  }

  returnPrevious = () =>{
    const values = this.props.history.location.state;

    if(typeof values === 'undefined'){
      this.props.history.push("/recibidos");
    }
    else{
      this.props.history.push(`/${values.previous}/${typeof(values.tab) !== 'undefined'? values.tab : 0}/${typeof(values.page) !== 'undefined'? values.page : 0}`)
    }

  }

  closeModalError = () => {
    this.setState({ errorMessageUpload: false })
  }

  componentWillUnmount () {
    this.save.cancel()
    if (this.subs !== undefined) {
      this.subs.unsubscribe()
    }
  }

  componentDidUpdate (prevProps) {
    const locationChanged = this.props.location !== prevProps.location
    if (locationChanged && this.props.match.params.id === 'new') {
      DocStore.getDoc('new').then(r => {
        this.setState({doc: r.data, isLoaded: true})
        this.setParams();
      })
    }
  }

  // set_physical_params = () => {
  //   const { doc, isLoaded } = this.state;
  //
  //   if(isLoaded){
  //     //I need this values for sent_physical
  //     const total_sents = doc.readDetail
  //
  //     //I filter doc's sent_physical
  //     const total_sent_physicals = total_sents.filter(x => x.sent_physical === true)
  //
  //     this.setState({ total_sent_physicals: total_sent_physicals.length, total_sents: total_sents.length})
  //
  //     //if consts are number and greather than 0
  //     if((typeof total_sents.length === 'number') && (total_sents.length > 0) && (typeof total_sent_physicals.length === 'number') && (total_sent_physicals.length > 0)){
  //       if(total_sents.length === total_sent_physicals.length){
  //         this.setState({ all_physical_sents: true })
  //       }
  //     }
  //   }
  // }

  // printDocument = () =>{
  //   const id = this.state.doc.id;
  //   DocStore.printDoc(id).then(
  //     r => {
  //       if (r.status === 200) {
  //         let link = document.createElement('a');
  //           link.href = window.URL.createObjectURL(r.data);
  //           link.download = `oficio-${id}.pdf`;
  //           link.click();
  //       }
  //       else{
  //         this.props.snack('Ocurrió un error al imprimir el oficio', 'warning')
  //       }
  //     },
  //     e => {
  //         this.props.snack('Error al imprimir el oficio', 'warning')
  //     }
  //   )
  // }

  printDocument = () => {
      window.print();
    }

  // redux, but we are too advanced in the development to implement that
  shouldComponentUpdate (nextProps, nextState) {
    const locationChanged = this.props.location !== nextProps.location
    if (!this.state.isLoaded || locationChanged) return true

    const ns = nextState
    const ts = this.state
    return (
      ns.valid !== ts.valid ||
      ns.doc.sent !== ts.doc.sent ||
      ns.doc.readDetail !== ts.doc.readDetail ||
      ns.doc.to !== ts.doc.to ||
      ns.doc.from.email !== ts.doc.from.email ||
      ns.doc.pending !== ts.doc.pending ||
      ns.doc.from.id !== ts.doc.from.id ||
      ns.doc.files.length !== ts.doc.files.length ||
      ns.saveMessage !== ts.saveMessage ||
      ns.doc.revisionNotes !== ts.doc.revisionNotes ||
      ns.doc.notice_user_list !== ts.doc.notice_user_list ||
      ns.doc.notices_attributes !== ts.doc.notices_attributes ||
      ns.alreadyAdded !== ts.alreadyAdded ||
      ns.preview !== ts.preview ||
      ns.isOpenTempProfile !== ts.isOpenTempProfile ||
      ns.doc.ext_name !== ts.doc.ext_name ||
      ns.doc.ext_job_title !== ts.doc.ext_job_title ||
      ns.doc.external !== ts.doc.external ||
      ns.allowEdit !== ts.allowEdit ||
      ns.errorMessageUpload !== ts.errorMessageUpload ||
      ns.doc.subject !== ts.doc.subject ||
      ns.doc.parent_folio !== ts.doc.parent_folio ||
      ns.doc.parent_link !== ts.doc.parent_link ||
      ns.doc.parent_to !== ts.doc.parent_to ||
      ns.doc.parent_from !== ts.doc.parent_from ||
      ns.doc.check_replier !== ts.doc.check_replier ||
      ns.doc.requested_physical !== ts.doc.requested_physical ||
      ns.doc.received_physical !== ts.doc.received_physical ||
      ns.doc.reply_info !== ts.doc.reply_info
    )
  }

  render () {
    const { classes } = this.props

    if (!this.state.isLoaded) return null
    const {doc, valid, saveMessage, noteAdded, preview, alreadyAdded, tempProfile, isOpenTempProfile, params, allowEdit, errorMessageUpload } = this.state

    //Is from, reviewing doc created by delegated
    const isFromUser =
      doc.from.email === DocStore.email() &&
      doc.created_by.email !== DocStore.email()
    //Is delegated, viewing doc with different from
    const isCreatedByUser =
      doc.created_by.email === DocStore.email() &&
      doc.from.email !== DocStore.email()
    //Is the doc owner and creator
    const isCreatedAndFromUser =
      doc.created_by.email === DocStore.email() &&
      doc.from.email === DocStore.email()
    //if doc has a sign request and has pending notes is rejected otherwise is inRevision, sent if is in table sent
    const docStatus =
      ((doc.pending || doc.pending_approval) && (doc.notes))
        ? 'rejected'
        : ((doc.pending || doc.pending_approval) && (!doc.notes))
        ? 'inRevision'
        : doc.sent
          ? 'sent'
          : 'inEdition'
    //Min reqs are body valid (more than 50 char) and id reciever

    let missingMinRequirements = (!valid || !doc.to.id || (typeof doc.subject !== 'string'));
    if(doc.external && doc.ext_name !== null){
      missingMinRequirements = (!valid || doc.ext_name.length === 0 || (typeof doc.subject !== 'string') );
    }

    const role = isFromUser
      ? 'revisor'
      : isCreatedByUser
        ? 'delegated'
        : isCreatedAndFromUser
          ? 'owner'
          : 'isToUser'
    const disableEdit = doc.check_replier? false : doc.pending_approval && role ==='owner' && docStatus !== 'rejected'? true : allowEdit === true? false :
      role === 'delegated' && docStatus === 'rejected'
        ? false
        : role === 'owner' && doc.pending === false
        ? false
        : role === 'delegated' && docStatus === 'inEdition'
          ? doc.sent
          : true

    const user_id = params.id;

    const noticesList = []

    let hasForwarded = false

    if(doc.notices_attributes.length >=1 )
      doc.notices_attributes.map(cc =>(
        cc.from_id.toString() === user_id? hasForwarded= true :  null
      ))

    if (doc.notices_attributes.length >= 1 && (doc.sent || doc.pending)) {
        doc.notices_attributes.forEach(cc => {
          noticesList.push(cc.id)
          cc.notice_users_attributes.map(nu => {
            return (nu.external ? nu.ext_name : nu.to.id.toString() === user_id ? noticesList.push(cc.id) : '')
          })
        })
    }

    const DateDoc = moment(doc.date).format('LL');
    const DateAndTimeDoc = DateDoc + ' - ' + doc.time
    const url = this.props.location.pathname;

    //docDetailsRender && docDetailsPrintRender
    let docDetailsRender = <Typography className="no_print emptyTab">No hay reenvios/CC</Typography>;
    let docDetailsPrintRender = null;

    if(noticesList.length > 0 && doc.sent){
      docDetailsRender = (
          <DocAdditionalDetails
            needsAproval={doc.needs_review.length > 0? true : false}
            originalTo={doc.needs_review.length > 0? doc.needs_review[0].name.title+' '+ doc.needs_review[0].name.full : ''}
            noticeAttributes={doc.notices_attributes}
            noticesList={noticesList}
            print={false}
          />
      );

      //I clone element and I add print prop
      docDetailsPrintRender = React.cloneElement(docDetailsRender, { print: true });
    }

    //DocHistoryDetails
      const docHistoryRender = (
          <DocHistoryDetails
            folio={this.state.doc.parent_folio}
            link={this.state.doc.parent_link}
            to={this.state.doc.parent_to}
            from={this.state.doc.parent_from}
            info={this.state.doc.reply_info}
          />
      );

      const docPhysicalRender = (
        <DocPhysicalDetails
          role={role}
          readDetail={doc.readDetail}
          sendNotificationForPhysical={this.onSendPhysicalDoc} />
      );

    //docPrintDetailsRender
    let docPrintDetailsRender = null;
    if(role === 'owner' || role === 'revisor'){
      docPrintDetailsRender = (
          <DocPrintDetails className="printable" doc={doc}/>
      );
    }

    let note = '';
    if(doc.notices_attributes[0]){
      note = doc.notices_attributes[0].note;
    }

    //ccrender
    let ccListRender = null;
    if(doc.notice_user_list.length > 0 && (docStatus === 'inEdition' || docStatus === 'inRevision')){
      ccListRender = (
        <RenderCC ccList={doc.notice_user_list} ccNote={note} show/>
      );
    }

    let acknowledgment = null;

    if((doc.sent === true) && (doc.created_by.id !== Number(user_id)) && (doc.from.id !== Number(user_id)) && doc.has_approver === false){
        acknowledgment = (
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h6" align="right" color="primary" className="acknowledgment">ACUSE DE RECIBIDO ENVIADO</Typography>
            </Grid>
         </Grid>
        );
      }

    let checkUserInCC = false

    //I search if I'm in notice_user_list
     doc.notice_user_list.forEach(u => {

       if(!u.external){
         if(u.to.id === Number(user_id)){
          checkUserInCC = true
        }
       }

     });

     //print
     let printButton = null;

     if(doc.sent){
       printButton = (
           <IconButton onClick={this.printDocument}>
             <Print/>
           </IconButton>
        );
     }

     const returnButton = (
       <CustomTooltip  title="Volver" placement="right">
         <IconButton onClick={this.returnPrevious}>
           <ArrowBack/>
         </IconButton>
       </CustomTooltip>
     );

    //renderEditor
    let renderEditor = (
      <div className={classes.root}>
        {acknowledgment}
        {ccListRender}
        <DocEditorRender
          role={role}
          disableEdit={disableEdit}
          saveMessage={saveMessage}
          hasForwarded={hasForwarded}
          doc={doc}
          preview={preview}
          onDateChange={this.onDateChange}
          onSubjectChange={this.onSubjectChange}
          onToChange={this.onToChange}
          onEventSave={this.onEventSave}
          onAddCC={this.onAddCC}
          onAddExternalCC={this.onAddExternalCC}
          onDeleteCC={this.onDeleteCC}
          onCcNoteChange={this.onCcNoteChange}
          onReset={this.onReset}
          alreadyAdded={alreadyAdded}
          onBodyChange={this.onBodyChange}
          onFileUpload={this.onFileUpload}
          onDeleteFile={this.onDeleteFile}
          isBodyValid={this.isBodyValid}
          onSwitchFrom={this.onSwitchFrom}
          docStatus={docStatus}
          user_id={user_id}
          onPreview={this.openPreview}
          noteAdded={noteAdded}
          missingMinRequirements={missingMinRequirements}
          onSendComment={this.onSendComment}
          onSendCommentApprove={this.onSendCommentApprove}
          updateDocForward={this.updateDocForward}
          valid={valid}
          can_create={params.can_create}
          can_edit_date={params.can_edit_date}
          can_trace={params.can_trace}
          isDelegate={params.isDelegate}
          hasDelegates={params.hasDelegates}
          isOpenTempProfile={isOpenTempProfile}
          tempProfile={tempProfile}
          closeTempProfileModal={this.closeTempProfileModal}
          openTempProfileModal={this.openTempProfileModal}
          DateDoc={DateDoc}
          DateAndTimeDoc={DateAndTimeDoc}
          url={url}
          onSendAprove={this.onSendAprove}
          onChangeAddressee={this.onChangeAddressee}
          onChangeTypeAddressee={this.onChangeTypeAddressee}
          noticesList={noticesList.length}
          editDoc={this.disableEditDoc}
          errorMessageUpload={errorMessageUpload}
          onReplyDoc={this.onReplyDoc}
          onAskPhysicalDoc={this.onAskPhysicalDoc}
          checkUserInCC={checkUserInCC}
          closeModalError={this.closeModalError}
          docDetailsRender={docDetailsRender}
          docHistoryRender={docHistoryRender}
          docPhysicalRender={docPhysicalRender}
          printButton={printButton}
          returnButton={returnButton}
          received_physical={doc.received_physical}
          requested_physical={doc.requested_physical}
        />
        {docPrintDetailsRender}
        {docDetailsPrintRender}
      </div>
    );

    if(preview){
      renderEditor = (
        <div>
          <Dialog
            maxWidth='md'
            open={preview}
            fullWidth={true}
            className="preview_modal"
          >
            <Grid container >
              <Hidden smDown>
                <Grid item xs={12} sm={12} md={7} lg={7} xl={7}  className="container_preview">
                  <DocEditorRender
                    role={role}
                    disableEdit={disableEdit}
                    saveMessage={saveMessage}
                    hasForwarded={hasForwarded}
                    doc={doc}
                    preview={preview}
                    onDateChange={this.onDateChange}
                    onSubjectChange={this.onSubjectChange}
                    onToChange={this.onToChange}
                    onEventSave={this.onEventSave}
                    onAddCC={this.onAddCC}
                    onAddExternalCC={this.onAddExternalCC}
                    onDeleteCC={this.onDeleteCC}
                    onCcNoteChange={this.onCcNoteChange}
                    onReset={this.onReset}
                    alreadyAdded={alreadyAdded}
                    onBodyChange={this.onBodyChange}
                    onFileUpload={this.onFileUpload}
                    onDeleteFile={this.onDeleteFile}
                    onSwitchFrom={this.onSwitchFrom}
                    DateDoc={DateDoc}
                    DateAndTimeDoc={DateAndTimeDoc}
                    url={url}
                    errorMessageUpload={errorMessageUpload}
                    onReplyDoc={this.onReplyDoc}
                    onAskPhysicalDoc={this.onAskPhysicalDoc}
                    docDetailsRender={docDetailsRender}
                    docHistoryRender={docHistoryRender}
                    docPhysicalRender={docPhysicalRender}
                  />
              </Grid>
            </Hidden>
            <Grid item xs={12} sm={12} md={5} lg={5} xl={5} className="container_preview_confirm">
              <SectionConfirm
                folio={doc.folio}
                created_by={doc.created_by}
                to={doc.to}
                from={doc.from}
                date={DateDoc}
                ccList={doc.notice_user_list}
                ccNote={note}
                closePreview={this.closePreview}
                onSend={this.onSend}
                role={role}
                external={doc.external}
                ext_name={doc.ext_name}
                ext_job_title={doc.ext_job_title}
                needsAproval={doc.needs_approval}
                onSendRev={this.ask_or_grant_revision}
                subject={doc.subject}
              />
            </Grid>
          </Grid>
          </Dialog>
        </div>
      );
    }

    return (
      renderEditor
    )
  }
}

const DocEditorRender = props => {
  const {
    doc,
    role,
    disableEdit,
    hasForwarded,
    saveMessage,
    preview,
    onDateChange,
    onSubjectChange,
    onToChange,
    onEventSave,
    onAddCC,
    onAddExternalCC,
    onDeleteCC,
    onCcNoteChange,
    onReset,
    alreadyAdded,
    onBodyChange,
    onFileUpload,
    onDeleteFile,
    isBodyValid,
    onSwitchFrom,
    noteAdded,
    docStatus,
    missingMinRequirements,
    user_id,
    onPreview,
    onSendComment,
    onSendCommentApprove,
    updateDocForward,
    valid,
    can_create,
    can_trace,
    can_edit_date,
    isDelegate,
    isOpenTempProfile,
    tempProfile,
    closeTempProfileModal,
    openTempProfileModal,
    DateAndTimeDoc,
    onSendAprove,
    url,
    onChangeAddressee,
    onChangeTypeAddressee,
    editDoc,
    errorMessageUpload,
    onReplyDoc,
    onAskPhysicalDoc,
    checkUserInCC,
    closeModalError,
    docDetailsRender,
    docHistoryRender,
    docPhysicalRender,
    printButton,
    returnButton,
    received_physical,
    requested_physical
  } = props;

  let requiredFieldmessage = null;

  if(!preview){
    requiredFieldmessage = (
      <DocRequiredField
         valid={valid}
         message={'*El contenido debe contener al menos 50 caracteres'}
       />
    );
  }

  let modalUploadError = null;

  if(errorMessageUpload){
    modalUploadError = (
      <ErrorMessageModal
         open={errorMessageUpload}
         close={closeModalError}
         message={'Error al subir los archivos, el peso máximo son 10MB y las extensiones permitidas son PDF, jpg, jpeg, doc, docx, xls y xlsx.'}
       />
    );
  }

  //docActionButtonsrender
  let docActionButtonsrender = (
    <DocActionButtons
      onPreview={onPreview}
      onSendComment={onSendComment}
      onSendCommentApprove={onSendCommentApprove}
      previousNotes={doc.revision_notes}
      noteAdded={noteAdded}
      role={role}
      docStatus={docStatus}
      missingMinRequirements={missingMinRequirements}
      to={doc.to}
      onToChange={onToChange}
      fromCC={user_id}
      docCC={doc.id}
      updateDocForward={updateDocForward}
      can_create={can_create}
      can_trace={can_trace}
      isDelegate={isDelegate}
      openTempModal={openTempProfileModal}
      needsReview={doc.needs_review}
      aproveDoc={onSendAprove}
      authorize={doc.can_authorize}
      needsRevision={doc.needs_approval}
      fromId={doc.from.id}
      hasApprover={doc.has_approver}
      editDoc={editDoc}
      pendingApproval={doc.pending_approval}
      hasCC={doc.notice_user_list.length > 0? true : false }
      handleReplyDoc={onReplyDoc}
      handleAskPhysicalDoc={onAskPhysicalDoc}
      userInCC={checkUserInCC}
      delegate_reply={doc.delegate_reply}
      belongs_to_group={(typeof doc.belongs_to_group !== 'boolean')? false : doc.belongs_to_group}
      forGroup={(doc.to.group)? true : false}
      requested_physical={requested_physical}
      received_physical={received_physical}
      />
  );

  if(preview){
    docActionButtonsrender = null;
  }
  //

  //temp modal
  let tempModal = null;
  if(isOpenTempProfile){
    tempModal = (
      <TempProfileModal
        open={isOpenTempProfile}
        profile={tempProfile}
        onClose={closeTempProfileModal}
        user_id={user_id}/>
    );
  }
  //
  let note = '';
  if(doc.notices_attributes[0]){
    note = doc.notices_attributes[0].note;
  }

  let oficialNote = null;

  if(process.env.REACT_APP_DISABLED2FA === 'true'){
    oficialNote = (
      <Grid container><Grid item xs={12} style={{textAlign:'center', color:'gray'}}><span>Este oficio no tiene validez oficial.</span></Grid></Grid>
    );
  }

  let physicalNote = null;
  // if the length of readDetail with request_physical true is greather than 0 or doc was requested or recieved show the text
  if(doc.readDetail.filter(d => d.sent_physical).length > 0 || doc.requested_physical || doc.received_physical){
    physicalNote = (
      <Grid container className="no_print">
        <Grid item xs={12} style={{textAlign:'right', color:'gray'}}>
          <span>*La presente solicitud requiere su presentación en formato físico ante esta dependencia universitaria,
            <br/>por lo que el trámite requerido no podrá ser procesado hasta su recepción en esa modalidad dada la
            <br/> naturaleza específica del mismo.
          </span>
        </Grid>
      </Grid>
    );
  }

  return(
    <div>
      <Grid container
         direction="row"
         alignItems="flex-start">
        <Grid item sm={6} md={6} lg={6} xs={6}>
          {returnButton}
        </Grid>
        <Grid item sm={6} md={6} lg={6} xs={6} className="right">
          {printButton}
        </Grid>
      </Grid>
      <GroupedDetails
        sent={doc.sent}
        additionalDetails={docDetailsRender}
        historyDetails={docHistoryRender}
        physicalDetails={docPhysicalRender}/>
      {oficialNote}
      {physicalNote}
      <DocHeader
        onDateChange={onDateChange}
        onSubjectChange={onSubjectChange}
        date={doc.date}
        folio={doc.folio}
        to={doc.to}
        onToChange={onToChange}
        onEventSave={onEventSave}
        disabled={disableEdit || doc.sent || preview}
        read={(role === 'owner' || role === 'revisor' || role === 'delegated') && doc.read === true}
        canViewReadDetail={doc.sent && (role === 'owner' || role === 'revisor' || hasForwarded || role === 'delegated') }
        readDetail={doc.readDetail}
        event={doc.event}
        saveMessage={saveMessage}
        ccList={doc.notice_user_list}
        onAddCC={onAddCC}
        onAddExternalCC={onAddExternalCC}
        onDeleteCC={onDeleteCC}
        ccNote={note}
        onCcNoteChange={onCcNoteChange}
        onReset={onReset}
        alreadyAdded={alreadyAdded}
        readCount={doc.read_count}
        preview={preview}
        can_edit_date={can_edit_date}
        changeAddressee={onChangeAddressee}
        changeTypeAddressee={onChangeTypeAddressee}
        external={doc.external}
        ext_name={doc.ext_name}
        ext_job_title={doc.ext_job_title}
        subject={typeof doc.subject !== 'string'? '' :  doc.subject}
        location={(disableEdit || doc.sent || preview) ? doc.address.city : doc.location}
      />
      <DocBody
        key={doc.id}
        body={doc.body}
        files={doc.files}
        onChange={onBodyChange}
        disabled={disableEdit || doc.sent || preview}
        onFileUpload={onFileUpload}
        onDeleteFile={onDeleteFile}
        isValid={isBodyValid}
        preview={preview}
      />
      {requiredFieldmessage}
      {modalUploadError}
      <DocFooter
        slogan={doc.slogan}
        address={doc.address}
        telephone={doc.telephone}
        from={doc.from}
        created_by={doc.created_by}
        onSwitchFrom={onSwitchFrom}
        disabled={disableEdit || doc.sent || preview}
        showSign={doc.sent}
        preview={preview}
        can_create={can_create}
        isDelegate={isDelegate}
        user_id={user_id}
        DateAndTimeDoc={DateAndTimeDoc}
        role={role}
        docStatus={docStatus}
        url={url}
        check_replier={doc.check_replier}
        doc_id={doc.parent_id}
       />
       {docActionButtonsrender}
       {tempModal}
  </div>
  )
}

const SectionConfirm = props => {
  const { folio, created_by, to, from, date, ccNote, ccList, closePreview, onSend, role, external, ext_name, ext_job_title, needsAproval, onSendRev, subject } = props;
  //render ccList
  let renderCCList = null;
  if(ccList.length >  0){
    renderCCList = (
      <RenderCC ccList={ccList} ccNote={ccNote}/>
    );
  }

  //action
  let action =  () => onSend(role);

  //render action button
  let actionButtonText = 'Enviar oficio';
  if(role === 'delegated'){
    actionButtonText = 'Solicitar firma'
  }

  if(needsAproval === true){
    if(role === 'owner'){
      actionButtonText = 'Firmar y solicitar revisión'
      action =  () => onSendRev(role);
    }
    // else{
    //   actionButton = 'Enviar revisión'
    // }
  }

  let actionButton = (
    <Grid item>
      <Button
      variant="contained"
      color="primary"
      onClick={action}
      >
      {actionButtonText}
      </Button>
    </Grid>
  );

  //
  let addressee = to.name.title + " " + to.name.full;

  if(external){
    addressee = ext_name + ' - ' + ext_job_title ;
  }

  return(
    <div className="section_confirm">
      <Grid container>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="title-confirm">Confirmar datos</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Asunto:</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="data-confirm">{subject}</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Oficio dirigido a:</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="data-confirm">{addressee}</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Firmado por:</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="data-confirm">{from.name.title + " " +from.name.full}</p></Grid>
            {renderCCList}
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Número de folio:</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="data-confirm">{folio}</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Fecha:</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="data-confirm">{date}</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Elaborado por:</p></Grid>
          <Grid item sm={12} md={12} lg={12} xs={12}><p className="data-confirm">{created_by.name.full}</p></Grid>
          <Grid container spacing={8} className="action_buttons preview_buttons">
            <Grid item>
              <Button
              variant="outlined"
              color="primary"
              onClick={closePreview}
              >
              Cancelar
              </Button>
            </Grid>
            {actionButton}
        </Grid>
      </Grid>
    </div>
  )
}

const RenderCC = props => {
  const { ccNote, ccList, show } = props;
  //noteCCRender
  let noteCCRender = null;
  if(ccNote !== ""){
    noteCCRender = (
      <div>
        <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Nota para destinatarios con copia:</p></Grid>
        <Grid item sm={12} md={12} lg={12} xs={12}><p className="data-confirm">{ccNote}</p></Grid>
      </div>
    );
  }
  //

  //ccrender
  let ccrender = (
    <div className={ccList.length > 3? "ccscroll" : "" }>
      <Grid item sm={12} md={12} lg={12} xs={12}><p className="subtitle-confirm">Con copia para:</p></Grid>
      {ccList.map((person, i) => {
        return(
            <Grid item sm={12} md={12} lg={12} xs={12} key={Math.floor(Math.random()*1000)}><p className="data-confirm">
              {person.external? person.ext_name : person.to.name.title + " " + person.to.name.full}</p>
            </Grid>
        )
      })}
      {noteCCRender}
    </div>
  );

  if(show){
    const styleSection = "ccSection ccSectionShow";
    ccrender = (
      <div className={styleSection}>
        <p><strong>Oficio con copia para: </strong>
          {ccList.map((person, i) => {
            return(<span key={Math.floor(Math.random()*1000)}>{person.external? person.ext_name + ',' : person.to.name.title + " " + person.to.name.full + ','}</span>)
          })}
        </p>
        <p><strong>Nota para destinatarios con copia: </strong>
        <span style={{ wordWrap: 'break-word'}}>{ccNote}</span>
        </p>
      </div>
    );
  }

  return(
    ccrender
  )
}

DocEditor.propTypes = {
  match: PropTypes.object.isRequired
}
export default withStyles(styles)(withSnack(DocEditor))



// WEBPACK FOOTER //
// ./src/components/containers/DocEditor.js